import React, { useState } from 'react'
import { Button } from '@mobiscroll/react-latest'
import { Link, withRouter, RouteComponentProps } from 'react-router-dom'
import GoinFlow from 'src/components/icons/ui/GoinFlow'
import { RIDER_PORTAL_MAIN_PATH, RIDER_PORTAL_UI_MESSAGES } from 'src/constants/rider-portal'

interface MenuLinksProps extends RouteComponentProps {}
const {
  auth: { signIn },
  footer: { flow, goin, goinMyWay, home, products }
} = RIDER_PORTAL_UI_MESSAGES

const menuLinksClasses = 'cursor--pointer font-medium menu-links px1 text-center text-sm'

const MenuLinks = ({ location }: MenuLinksProps) => {
  const getLinkClasses = (path: string) => {
    const isActive = location.pathname === path
    return `${menuLinksClasses} ${isActive ? 'font-green1' : 'font-black1'}`
  }

  return (
    <>
      <Link className={getLinkClasses(RIDER_PORTAL_MAIN_PATH)} to={RIDER_PORTAL_MAIN_PATH}>
        {home}
      </Link>
      <Link className={getLinkClasses(`${RIDER_PORTAL_MAIN_PATH}/booking`)} to={`${RIDER_PORTAL_MAIN_PATH}/booking`}>
        {goinMyWay}
      </Link>
      <Link className={getLinkClasses(`${RIDER_PORTAL_MAIN_PATH}/products`)} to={`${RIDER_PORTAL_MAIN_PATH}/products`}>
        {products}
      </Link>
      <Link to={RIDER_PORTAL_MAIN_PATH}>
        <Button className='mbsc-rider-portal-success-btn menu-signin-btn'>{signIn}</Button>
      </Link>
    </>
  )
}

const WrappedMenuLinks = withRouter(MenuLinks)

const MenuBar = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  const toggleMenu = () => {
    setMenuOpen(prev => !prev)
  }

  return (
    <nav className='navbar mt3'>
      <div className='navbar__container'>
        <div className='navbar__logo'>
          <GoinFlow className='svg-color-green1' />
          <span>
            <span className='bold font-green1 text-2xl'>{goin}</span>
            <span className='font-green1 font-light text-2xl'>{` ${flow}`}</span>
          </span>
        </div>
        <div className={`navbar__links ${menuOpen ? 'open' : ''}`}>
          <WrappedMenuLinks />
        </div>
        <Button
          aria-expanded={menuOpen}
          ariaLabel='Toggle menu'
          className='navbar__toggle'
          variant='flat'
          onClick={toggleMenu}
          onKeyDown={(e: React.KeyboardEvent) => e.key === 'Enter' && toggleMenu()}
        >
          <div className={`hamburger ${menuOpen ? 'open' : ''}`}>
            <span />
            <span />
            <span />
          </div>
        </Button>
      </div>
    </nav>
  )
}

export default withRouter(MenuBar)



// WEBPACK FOOTER //
// ./src/components/riders/rider-portal/common/MenuBar.tsx